export const LIBRARY_PER_PAGE = 8;
